module.exports = __webpack_public_path__ + "static/result_jeju-34f839e6fffe823f1e1473a5102e0119.png";